/*
 * Parc Fermé — Yotpo Loyalty (Race Rewards©) live-balance helper.
 * Source/pattern confirmed via official Yotpo docs (Aug 2026):
 *   - Loader script: https://support.yotpo.com/docs/implementing-yotpo-loyalty-referrals-modules-with-single-page-application-spa
 *     <script async src="https://cdn-widgetsrepository.yotpo.com/v1/loader/<GUID>"></script>
 *   - Widget embed: <div class="yotpo-widget-instance" data-yotpo-instance-id="ID"></div> + yotpoWidgetsContainer.initWidgets()
 *   - Fetch Customer Details (points balance / tier): https://loyaltyapi.yotpo.com/reference/fetch-customer-details
 *     (server-side, API-key authenticated — not safe/available to call directly from the storefront).
 * There is no documented, stable client-side JS getter (e.g. window.swellAPI.getCustomerDetails) that
 * survives the Swell→Yotpo rebrand for anonymous/unauthenticated theme JS to call directly. Given that,
 * this helper takes the safest available real path: it mounts CMC's own known legacy "header" widget
 * instance (623884 — previously used store-side to show the logged-in customer's balance/tier) off-
 * screen, lets Yotpo's own script identify + populate it via the Shopify customer session (already
 * confirmed working per BUILD-LOG's Aug 2026 401 fix), then best-effort parses the rendered text for a
 * points number and a known tier name. This is honestly a best-effort scrape, not a documented API —
 * logged here and in BUILD-LOG so a future session can replace it if Yotpo ships a real public getter.
 * Graceful degradation: any failure/timeout resolves { points: null, tier: null } and consumers keep
 * their UI hidden.
 */
(function () {
  var LOADER_SRC = 'https://cdn-widgetsrepository.yotpo.com/v1/loader/7_xlVCJrNQtmZNgcLfMupA';
  var HEADER_WIDGET_INSTANCE_ID = '623884';
  var POLL_INTERVAL_MS = 300;
  var TIMEOUT_MS = 10000;
  var TIER_NAMES = ['Platinum', 'Gold', 'Silver', 'Bronze', 'VIP', 'Podium', 'Pole Position', 'Champion'];

  var cachedPromise = null;

  function ensureLoaderScript() {
    var already = document.querySelector('script[src*="cdn-widgetsrepository.yotpo.com/v1/loader"]');
    if (already) return;
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = LOADER_SRC;
    document.head.appendChild(s);
  }

  function ensureHiddenWidgetMount() {
    if (document.getElementById('pf-rewards-mount')) return document.getElementById('pf-rewards-mount');
    var mount = document.createElement('div');
    mount.id = 'pf-rewards-mount';
    mount.setAttribute('aria-hidden', 'true');
    mount.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;left:-9999px;top:auto;';
    var widget = document.createElement('div');
    widget.className = 'yotpo-widget-instance';
    widget.setAttribute('data-yotpo-instance-id', HEADER_WIDGET_INSTANCE_ID);
    mount.appendChild(widget);
    document.body.appendChild(mount);
    return mount;
  }

  function tryInitWidgets() {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      try { window.yotpoWidgetsContainer.initWidgets(); } catch (e) { /* no-op */ }
      return true;
    }
    return false;
  }

  function parseBalance(text) {
    if (!text) return null;
    var numMatch = text.replace(/,/g, '').match(/([\d]{1,7})\s*(points|pts)?/i);
    var points = null;
    if (numMatch) {
      var n = parseInt(numMatch[1], 10);
      if (!isNaN(n)) points = n;
    }
    var tier = null;
    for (var i = 0; i < TIER_NAMES.length; i++) {
      if (text.indexOf(TIER_NAMES[i]) !== -1) { tier = TIER_NAMES[i]; break; }
    }
    if (points === null && tier === null) return null;
    return { points: points, tier: tier };
  }

  function poll(resolve) {
    if (!window.customerData || !window.customerData.id) {
      // Not logged in per Shopify's own customer object — no point polling.
      resolve({ points: null, tier: null });
      return;
    }
    ensureLoaderScript();
    var mount = ensureHiddenWidgetMount();
    var start = Date.now();
    var timer = setInterval(function () {
      tryInitWidgets();
      var text = (mount.innerText || mount.textContent || '').trim();
      var parsed = parseBalance(text);
      if (parsed && parsed.points !== null) {
        clearInterval(timer);
        resolve(parsed);
        return;
      }
      if (Date.now() - start >= TIMEOUT_MS) {
        clearInterval(timer);
        resolve({ points: null, tier: null });
      }
    }, POLL_INTERVAL_MS);
  }

  window.pfRewards = {
    get: function () {
      if (cachedPromise) return cachedPromise;
      cachedPromise = new Promise(function (resolve) {
        poll(function (result) {
          try {
            document.dispatchEvent(new CustomEvent('pf:rewards', { detail: result }));
          } catch (e) { /* no-op */ }
          resolve(result);
        });
      });
      return cachedPromise;
    }
  };
})();
